import LayoutDashboard from "../layouts/LayoutDashboard";
// import BasicRouterView from "../components/BasicRouterView.vue";
// import pdt2Routes from "../modules/permissao/routes";
import pdtRoutes from "../modules/permissaoDeTrabalho/routes";
import cseRoutes from "../modules/controleEmocional/routes";
import orgRoutes from "../modules/organizacional/routes";
import office from "../modules/backOffice/routes";
import terceirosRoutes from "../modules/terceiros/routes";
import ferramentasAdmRoutes from "../modules/ferramentasAdm/routes";
import StyleGuide from "../views/StyleGuide.vue";
import requisicaoRoutes from "../modules/requisicao/routes";
import relRoutes from "../modules/relatorios/routes";
import ctdRoutes from "../modules/centralDownloads/routes";
import tduRoutes from "../modules/termosDeUso/routes";
import biometriaRoutes from "../modules/biometria/routes";
import userRoutes from "../modules/legado/usuarios/routes";
import altRoutes from "../modules/alertas/routes";
import produtosRoutes from "../modules/produtos/routes";
import catalogoRoutes from "../modules/legado/catalogo/routes";
import segurancaRoutes from "../modules/seguranca/routes";
import centroDeCustoRoutes from "../modules/centroDeCusto/routes";
import perfisRoutes from "../modules/perfis/routes";
import configuracaoRoutes from "../modules/configuracao/routes";
import integracaoRoutes from "../modules/legado/integracao/routes";
import grupoProdutosRoutes from "../modules/legado/grupoProdutos/routes";
import notaFiscalRoutes from "../modules/legado/notaFiscal/routes";
import treinamentoRoutes from "../modules/legado/treinamento/routes";
import processosRoutes from "../modules/legado/processos/routes";
import ordemRoutes from "../modules/legado/ordem/routes";
import maquinaRoutes from "../modules/legado/maquina/routes";
import ajusteEstoque from "../modules/legado/ajusteEstoque/routes";
import adminPostos from "../modules/legado/adminPostos/routes";
import adminMultpex from "../modules/legado/adminMultpex/routes";
import estoque from "../modules/legado/estoque/routes";
import transferenciaRoutes from "../modules/legado/transferencia/routes";
import inventario from "../modules/legado/Inventario/routes";
import compras from "../modules/legado/compras/routes";
import documentosRoutes from "../modules/documentos/routes";
import ativosRoutes from "../modules/ferramentaria/routes";
import indRoutes from "../modules/indicadores/routes";
import pickingRoutes from "../modules/picking/routes";
import catalogoWfRoutes from "../modules/legado/catalogoWF/routes";
import facialRoutes from "../modules/facial/routes";
import simplificadoRoutes from "../modules/simplificado/router";
import comprasSolicitante from "../modules/legado/comprasSolicitante/routes";
import produtosNovoRoutes from "../modules/produtosNovo/routes";
import usuarioNovo from "../modules/usuariosTeste/route";
import fiscalRouter from "../modules/legado/fiscal/router";
import refactorTablet from "../modules/refactorTablet/routes";
import gdcRoutes from "../modules/gestaoDeContrato/routes";
import assistenteIARoutes from "../modules/assistenteIA/routes";
import agenteVendasRoutes from "../modules/agenteVendas/routes";
import gestaoDeRiscosRoutes from "../modules/gestaoDeRiscos/routes";

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: LayoutDashboard,
    redirect: { name: "home" },
    meta: {
      icon: "home",
      label: "HOME",
    },
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          icon: "home",
          label: "Página inicial",
          breadcrumb: false,
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      },
      {
        path: "/styleguide",
        name: "styleguide",
        component: StyleGuide,
        meta: {
          show: false,
          icon: "wysiwyg",
          label: "styleguide",
        },
      },

      // pdt2Routes,

      pdtRoutes,
      orgRoutes,
      terceirosRoutes,
      cseRoutes,
      ferramentasAdmRoutes,
      office,
      requisicaoRoutes,
      relRoutes,
      ctdRoutes,
      altRoutes,
      tduRoutes,
      biometriaRoutes,
      userRoutes,
      produtosRoutes,
      centroDeCustoRoutes,
      catalogoRoutes,
      segurancaRoutes,
      perfisRoutes,
      configuracaoRoutes,
      integracaoRoutes,
      grupoProdutosRoutes,
      notaFiscalRoutes,
      treinamentoRoutes,
      processosRoutes,
      ordemRoutes,
      maquinaRoutes,
      ajusteEstoque,
      adminPostos,
      adminMultpex,
      estoque,
      transferenciaRoutes,
      inventario,
      compras,
      documentosRoutes,
      ativosRoutes,
      indRoutes,
      pickingRoutes,
      catalogoWfRoutes,
      facialRoutes,
      simplificadoRoutes,
      comprasSolicitante,
      produtosNovoRoutes,
      usuarioNovo,
      fiscalRouter,
      refactorTablet,
      gdcRoutes,
      assistenteIARoutes,
      agenteVendasRoutes,
      gestaoDeRiscosRoutes,
      // {
      //   path: "funcionarios",
      //   redirect: { name: "fucionarios.listar" },
      //   meta: {
      //     label: "FUNCIONÁRIOS",
      //     icon: "groups",
      //   },
      //   component: BasicRouterView,
      //   children: [
      //     {
      //       path: "listar",
      //       name: "fucionarios.listar",
      //       meta: {
      //         label: "LISTAR / EXCLUIR",
      //         icon: "list",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/funcionario/views/ListarFuncionario.vue"
      //         ),
      //     },
      //     {
      //       path: "adicionar",
      //       name: "funcionarios.adicionar",
      //       meta: {
      //         label: "ADICIONAR",
      //         icon: "person_add",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/funcionario/views/AdicionarFuncionario.vue"
      //         ),
      //     },
      //     {
      //       path: "editar/:id",
      //       name: "editar",
      //       meta: {
      //         label: "EDITAR",
      //         icon: "person_add",
      //         show: false,
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/funcionario/views/EditarFuncionario.vue"
      //         ),
      //     },
      //     {
      //       path: "funcoes",
      //       name: "fucionarios.funcao",
      //       meta: {
      //         label: "FUNÇÕES",
      //         icon: "list",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/funcoes/views/Funcoes.vue"
      //         ),
      //     },
      //   ],
      // },
      // {
      //   path: "centroCusto",
      //   redirect: { name: "centroCusto.listar" },
      //   meta: {
      //     label: "CENTRO DE CUSTO",
      //     icon: "paid",
      //   },
      //   component: BasicRouterView,
      //   children: [
      //     {
      //       path: "listar",
      //       name: "centroCusto.listar",
      //       meta: {
      //         label: "CRIAR / LISTAR",
      //         icon: "list",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/centroCusto/views/ListarCentroCusto.vue"
      //         ),
      //     },
      //   ],
      // },
      // {
      //   path: "processos",
      //   redirect: { name: "processos" },
      //   meta: {
      //     label: "PROCESSOS",
      //     icon: "work",
      //   },
      //   component: BasicRouterView,
      //   children: [
      //     {
      //       path: "funcoes",
      //       name: "funcao",
      //       meta: {
      //         label: "FUNÇÕES",
      //         icon: "list",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "funcionarios" */ "../modules/funcoes/views/Funcoes.vue"
      //         ),
      //     },
      //   ],
      // },
      //
      {
        path: "logout",
        name: "logout",
        meta: {
          label: "Logout",
          icon: "exit_to_app",
        },
      },
      {
        path: "/:catchAll(.*)*",
        component: () => import("../views/ErrorNotFound.vue"),
        name: "semAcesso",
        meta: {
          show: true,

          label: "404",
        },
      },
      {
        path: "/sem-permissao",
        component: () => import("../views/SemPermissão.vue"),
        name: "semPermissao",
        meta: {
          show: false,
          label: "403",
        },
      },
    ],
  },
];

export default routes;
